import React from 'react';
import UseCaseCard from '@/Components/UseCaseCard';
import { motion } from 'framer-motion';
//data
import { SeedVarietyCaseData } from '../../../Data/UseCaseData';
import MetaHead from '@/Components/MetaHead';
import MainHeading from '@/Components/MainHeading';
import SubHeading from '@/Components/SubHeading';
import ContentText from '@/Components/ContentText';
import { Button } from '@/Components/Button';
import Link from 'next/link';

export default function SeedVarietyUseCase() {
  return (
    <div>
      <MetaHead title="For Seed Company | Fyllo" />
      <div className="py-8 px-4 mx-auto max-w-screen-xl text-left lg:py-16 lg:px-6">
        <div className="mx-auto max-w-screen-xl">
          <MainHeading text="For Seed Companies" />
          <SubHeading text=" If you are a seed company looking to develop multiple seed tests blocks, Fyllo is a perfect partner to help you manage practices and climate across plots/location. With Fyllo, you can do the following:" />
        </div>
      </div>

      <div className="pb-10 grid md:grid-cols-2 gap-2 md:gap-10 mx-auto max-w-screen-xl p-5">
        {SeedVarietyCaseData.map((content, i) => {
          return (
            <div key={i} className="p-8 md:p-16 bg-slate-200 rounded-lg">
              <div className="text-7xl font-black text-slate-400">{`0${i + 1}.`}</div>
              <div className="pt-5">
                <div className="  text-xl md:text-2xl  font-bold text-green-800">{content.title}</div>
                <ContentText text={content.description} />
              </div>
            </div>
          );
        })}
      </div>
      <div className="grid place-items-center p-5">
        <Link href={'/contact#contact_form'}>
          <Button size="lg">Explore Partnership With Fyllo</Button>
        </Link>
      </div>
    </div>
  );
}
